'use client'

import Image from 'next/image'
import EmailSignUp from '@/components/ui/EmailSignUp'
import Container from '@/components/structure/Container'
import { Icon } from '@/icons/Icon'

export default function HomeInsights() {
  return (
    <Container reduced={true}>
      <section className="relative flex flex-col items-center overflow-hidden rounded-3xl bg-gradient-to-bl from-primary-950 to-black to-40% md:flex-row">
        <div className="flex w-full max-w-[440px] flex-col gap-6 p-8 xs:box-content xs:px-16 xs:pt-14 md:pb-16 md:pr-0">
          <div className="flex items-center gap-2 text-primary-500">
            <Icon name="laptop-chart-cols" />
            <span className="text-14 font-medium">Efficient insights</span>
          </div>
          <h2 className="text-balance font-heading text-36 font-bold text-white md:text-48">
            Feeling behind with AI?
          </h2>
          <p className="text-white/60">
            See how your team stacks up on AI adoption. Plus 4 truths everyone should know about AI
            right now.
          </p>
          <EmailSignUp focus="insights" theme="dark" maxWidth={440} />
        </div>

        <div className="relative z-10 flex w-full grow justify-center self-end">
          <Image
            src="/img/home/ai-insights.png"
            alt="Artificial Intelligence"
            width={408}
            height={408}
          />
        </div>

        <div className="absolute right-0 top-full z-0 -translate-y-1/2 md:top-0 md:-translate-y-2/3 md:translate-x-[20%]">
          <Image
            src="/img/home/ai-glyph.svg"
            alt="Efficient Insights"
            width={924}
            height={924}
            // `meticulous-ignore`: continuous `animate-spin` (60s rotation).
            // Meticulous catches different rotational frames between runs.
            data-review="ignore"
            className="meticulous-ignore animate-spin"
            style={
              {
                '--duration': '60000ms',
              } as React.CSSProperties & { '--duration': string }
            }
          />
        </div>
      </section>
    </Container>
  )
}
